import React, { useState } from 'react';
import { MoveHorizontalIcon } from 'lucide-react';
import { cases } from '../data/content';
import { SectionLabel } from './ui/SectionLabel';
import { Reveal } from './ui/Reveal';
export function BeforeAfterGallery() {
  return <section id="results" className="scroll-mt-24 bg-paper-off py-24 lg:py-40" data-id="element-71" data-mp="sk2w0awhwhbc">
      <div className="mx-auto max-w-shell px-5 sm:px-8 lg:px-12" data-id="element-72" data-mp="xi4eatm3kclr">
        <Reveal className="max-w-[760px]" data-id="element-73" data-mp="itzu1l7ebt0v">
          <SectionLabel data-id="element-74" data-mp="isyk5k249ckq">Results</SectionLabel>
          <h2 className="font-display mt-6 text-[clamp(2rem,4.2vw,3.3rem)] leading-[1.06] text-ink" data-id="element-75" data-mp="nkzqyqgimb3d">
            Real results.
            <br data-id="element-76" data-mp="9uwakg4bhblu" />
            Real smiles.
          </h2>
          <p className="mt-6 max-w-[52ch] text-[16.5px] leading-[1.8] text-ink/65" data-id="element-77" data-mp="esxs2wm3h2v7">
            See a few of the transformations achieved at Lima Dental Group. Drag the divider on
            each image to compare the before and after.
          </p>
        </Reveal>

        <div className="mt-14 grid gap-8 sm:grid-cols-2 lg:mt-20 lg:grid-cols-3 lg:gap-10" data-id="element-78" data-mp="4u8hlowj2koz">
          {cases.map((item, index) => <Reveal key={item.id} delay={Math.min(index, 2) * 0.07} data-id="element-79" data-mp="2lrfqy5zb9p3s" data-mpi={index}>
              <BeforeAfterSlider title={item.title} before={item.before} after={item.after} index={index + 1} data-id="element-80" data-mp="2lr7g0jmr0tv8" />
            </Reveal>)}
        </div>

        <p className="mt-10 text-[13px] text-ink/45" data-id="element-81" data-mp="27zsuo65dcgl0">
          Results may vary from patient to patient.
        </p>
      </div>
    </section>;
}
type SliderProps = {
  title: string;
  before: string;
  after: string;
  index: number;
};
function BeforeAfterSlider({
  title,
  before,
  after,
  index
}: SliderProps) {
  const [value, setValue] = useState(50);
  const inputId = `ba-slider-${index}`;
  return <figure data-id="element-82" data-mp="1obtgelblirau">
      <div className="relative aspect-square select-none overflow-hidden rounded-[8px] border border-ink/15" data-id="element-83" data-mp="1oba1ldh8sj11">
        <img src={after} alt={`After treatment: ${title}`} loading="lazy" className="absolute inset-0 h-full w-full object-cover" data-id="element-84" data-mp="1k9f2mfmsahqf" />
        <div className="absolute inset-0 overflow-hidden" style={{
        width: `${value}%`
      }} aria-hidden="true" data-id="element-85" data-mp="3odt0eldhkmo3">
          <img src={before} alt="" loading="lazy" className="absolute inset-0 h-full w-full max-w-none object-cover" style={{
          width: `${100 / Math.max(value, 1) * 100}%`
        }} data-id="element-86" data-mp="3t5t6ywo2adtn" />
        </div>

        <span className="pointer-events-none absolute left-3 top-3 rounded-[6px] bg-ink/85 px-2.5 py-1 text-[11px] font-medium uppercase tracking-[0.16em] text-white" data-id="element-87" data-mp="35enkvzrj2paw">
          Before
        </span>
        <span className="pointer-events-none absolute right-3 top-3 rounded-[6px] bg-white/90 px-2.5 py-1 text-[11px] font-medium uppercase tracking-[0.16em] text-ink" data-id="element-88" data-mp="3fdwhz1howk1h">
          After
        </span>

        <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 w-px bg-white" style={{
        left: `${value}%`
      }} data-id="element-89" data-mp="umck5fp9zg7c">
          <span className="absolute top-1/2 flex h-10 w-10 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-white text-ink shadow-[0_4px_18px_-6px_rgba(0,0,0,0.6)]" data-id="element-90" data-mp="2a6lkmoh9b8y3">
            <MoveHorizontalIcon className="h-4 w-4" strokeWidth={1.75} data-id="element-91" data-mp="20gjvdtd63khl" />
          </span>
        </div>

        <label htmlFor={inputId} className="sr-only" data-id="element-92" data-mp="1vh7ahe5uwnhn">
          Compare before and after: {title}
        </label>
        <input id={inputId} type="range" min={0} max={100} value={value} onChange={e => setValue(Number(e.target.value))} className="absolute inset-0 h-full w-full cursor-ew-resize appearance-none bg-transparent opacity-0" data-id="element-93" data-mp="1rfc9karu8c4e" />
      </div>
      <figcaption className="mt-4 flex items-center gap-3 text-[14px] text-ink/70" data-id="element-94" data-mp="3gtqtmhrwvatk">
        <span className="text-[12px] font-medium tracking-[0.18em] text-accent" data-id="element-95" data-mp="3bv74k8i0tiwz">
          {String(index).padStart(2, '0')}
        </span>
        {title}
      </figcaption>
    </figure>;
}